import { useDispatch, useSelector } from 'react-redux';
import { ACTION_TYPES } from 'store/ActionTypes';
import { getstore } from 'store/ssqstore';

export function useToast(): [string, number, string] {
  const state = useSelector((state: any): any => state.toast);
  return [state.type, state.seq, state.msg];
}

export type ToastType =
  | 'feedback'
  | 'bookmark'
  | 'bookmark-clear'
  | 'share'
  | 'selectorAdd'
  | 'selectorAdd-clear'
  | 'selectorCompare'
  | 'selectorCompare-clear'
  | 'selectorShare'
  | 'selectorAddOption'
  | 'selectorCompareTab'
  | 'selectorCompareTabHmi'
  | 'selectorCompareTabVfd'
  | 'selectorAddedTab'
  | 'selectorReset'
  | 'unknown'
  | 'msg';

export type FnShowToast = (type: ToastType, msg?: string) => void;

export function useShowToast(): FnShowToast {
  const dispatch = useDispatch();
  const showToast = (type: ToastType, msg?: string) => {
    dispatch({ type: ACTION_TYPES.TOAST.SHOW_TYPE, payload: { type, msg } });
  };
  return showToast;
}

export function showToastMsg(msg: string) {
  const store = getstore();
  if (!store) {
    console.error('store is not found');
    return;
  }
  store.dispatch({ type: ACTION_TYPES.TOAST.SHOW_TYPE, payload: { type: 'msg', msg } });
}

export function showToast(type: ToastType, msg?: string) {
  const store = getstore();
  if (!store) {
    console.error('store is not found');
    return;
  }
  store.dispatch({ type: ACTION_TYPES.TOAST.SHOW_TYPE, payload: { type, msg } });
}
